export enum AuthReducerType {
	LOGIN = "LOGIN",
	LOGOUT = "LOGOUT",
	UPDATE_TOKEN = "UPDATE_TOKEN",
}
